
import { Button, makeStyles, Typography, Theme } from "@mui/material";
import { shadows } from "@mui/system";
import React, { useEffect } from "react";
import './LocationPermission.scss';
//import getLocationInfo from '../../services/getLocationInfo';
import getBrowserInfo from '../../services/getBrowserInfo';
import { CircularProgress } from '@mui/material';
import muiStyles from '../../muiCustomStyles';


interface LocationPermissionProps {
    setView: (view: string) => void;
    payload: any;
}

const LocationPermission: React.FC<LocationPermissionProps> = ({ setView, payload }: LocationPermissionProps) => {
    const [locationinfo, setLocationInfo] = React.useState<{ [key: string]: any }>();
    const [browserprint, setBrowserprint] = React.useState(getBrowserInfo());
    const [loading, setLoading] = React.useState(false);

    muiStyles.buttonStyles.backgroundColor = payload.request.btn_color;
    muiStyles.buttonStyles['&:hover'].backgroundColor = payload.request.btn_color;
    muiStyles.buttonStyles.color = payload.request.btn_text_color;
    muiStyles.circleStyles.color = payload.request.btn_color;

    useEffect(() => {
        if ("permissions" in navigator) {
            navigator.permissions.query({ name: 'geolocation' })
            .then(res => {
                if(res.state === 'granted'){
                    getLocationInfoFu();
                }
            })
        }
    }, []);

    const getLocationSuccess = (position: any) => {
        console.log(position);
        let latitude = position.coords.latitude;
        let longitude = position.coords.longitude;
        let accuracy = position.coords.accuracy;
        
        let resp = {
            latitude: latitude,
            longitude: longitude,
            accuracy:accuracy

        }
        setLocationInfo(resp);
    };
    
    const getLocationError = (error: any) => {
        console.log(error);
        // continue with flow regardless
        setView(!payload.request.no_live_detector ? "CAMERAPERMISSION" : 'SELFIENODETECTOR');
        setLoading(false);
    };

    const getLocationInfoFu = () => {
        setLoading(true);
        console.log('try get location');
        if ("geolocation" in navigator) {
            // Access the API
            navigator.geolocation.getCurrentPosition(
                getLocationSuccess,
                getLocationError
            );
        } else {
            getLocationError("Error getting geolocation: no navigator.geolocation");
            // continue with flow regardless
            setView(!payload.request.no_live_detector ? "CAMERAPERMISSION" : 'SELFIENODETECTOR');
            setLoading(false);
        }
    };

    useEffect(() => {
        if(locationinfo && browserprint){
            const getSendFingerprint = async () => {
                console.log('try set fingerprint');
              try {
                if (payload != undefined && locationinfo != undefined) {
                  let timestamp = new Date().getTime();
                  let request = {
                    identity_number: payload.identity_number,
                    date_created: timestamp,
                    browserprint: browserprint,
                    locationinfo: locationinfo
                  }
                  const res = fetch(process.env.REACT_APP_SELFIE_ROOT_URL + "/v1/browserprint", {
                    method: 'post',
                    headers: {
                      'accept': 'application/json',
                      'Content-Type': 'application/json',
                      'X-Api-Key': payload?.hash ?? ''
                    },
                    body: JSON.stringify(request)
                  });
                  var response = (await res);
                  var result = await (response).json();
                  console.log("got result:" + JSON.stringify(result));
                  // SUCCESS: go lo Camera Permission View
                  setView(!payload.request.no_live_detector ? "CAMERAPERMISSION" : 'SELFIENODETECTOR');
                  setLoading(false);
                }
              } catch (err) {
                // TODO: what should happen if the request fails?
                console.log("got get error:" + err);
              }
            }
            getSendFingerprint();
        }
    }, [payload, locationinfo, browserprint]);
    return (
        <div className="inner">
                <div className="SelfieApp-content__box">
                    {(payload.request && payload.request.img_color && !payload.request.hide_icons) ?? <div className="SelfieApp-content__icon">
                        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M40.5 7.5C28.9141 7.5 19.5 16.9141 19.5 28.5C19.5 31.5625 20.8125 35.3867 22.7148 39.543C24.6172 43.6992 27.1328 48.1523 29.6445 52.2539C34.6719 60.4648 39.6953 67.2773 39.6953 67.2773L40.5 68.3672L41.3047 67.2773C41.3047 67.2773 46.3281 60.4648 51.3555 52.2539C53.8672 48.1523 56.3828 43.6992 58.2852 39.543C60.1875 35.3867 61.5 31.5625 61.5 28.5C61.5 16.9141 52.0859 7.5 40.5 7.5ZM40.5 9.5C51.0039 9.5 59.5 17.9961 59.5 28.5C59.5 30.9609 58.3125 34.668 56.4648 38.707C54.6172 42.75 52.1328 47.1484 49.6445 51.2109C45.3164 58.2812 41.5508 63.5078 40.5 64.9531C39.4492 63.5078 35.6836 58.2812 31.3555 51.2109C28.8672 47.1484 26.3828 42.75 24.5352 38.707C22.6875 34.668 21.5 30.9609 21.5 28.5C21.5 17.9961 29.9961 9.5 40.5 9.5ZM40.5 12.5C39.9492 12.5 39.5 12.9492 39.5 13.5C39.5 14.0508 39.9492 14.5 40.5 14.5C41.0508 14.5 41.5 14.0508 41.5 13.5C41.5 12.9492 41.0508 12.5 40.5 12.5ZM36.6562 13.0117C36.5547 13.0078 36.457 13.0195 36.3594 13.0469C35.8242 13.1875 35.5078 13.7344 35.6523 14.2695C35.7969 14.8047 36.3438 15.1211 36.875 14.9766C37.4102 14.832 37.7266 14.2852 37.582 13.75C37.4688 13.3281 37.0938 13.0273 36.6562 13.0117ZM44.375 13.0156C43.9258 13.0156 43.5312 13.3203 43.418 13.7539C43.2734 14.2891 43.5898 14.8359 44.125 14.9805C44.6562 15.1211 45.2031 14.8047 45.3477 14.2695C45.4922 13.7383 45.1758 13.1914 44.6406 13.0469C44.5547 13.0234 44.4648 13.0117 44.375 13.0156ZM32.9766 14.5117C32.8086 14.5117 32.6445 14.5586 32.5 14.6406C32.2695 14.7734 32.1016 14.9922 32.0352 15.25C31.9648 15.5078 32 15.7812 32.1367 16.0117C32.4102 16.4883 33.0234 16.6523 33.5 16.375C33.9766 16.0977 34.1406 15.4883 33.8633 15.0117C33.6836 14.6914 33.3438 14.5 32.9766 14.5117ZM47.9531 14.5117C47.6133 14.5273 47.3047 14.7148 47.1367 15.0117C47 15.2383 46.9648 15.5117 47.0352 15.7695C47.1016 16.0273 47.2695 16.2461 47.5 16.375C47.9766 16.6523 48.5898 16.4883 48.8633 16.0117C49.1406 15.5312 48.9766 14.9219 48.5 14.6445C48.3359 14.5469 48.1445 14.5039 47.9531 14.5117ZM29.9062 16.8906C29.6367 16.8906 29.375 16.9961 29.1875 17.1875C28.7969 17.5742 28.7969 18.2109 29.1875 18.5977C29.5742 18.9883 30.2109 18.9883 30.5977 18.5977C30.9883 18.2109 30.9883 17.5742 30.5977 17.1875C30.4141 17 30.168 16.8945 29.9062 16.8906ZM51.1211 16.8906C50.8516 16.8867 50.5898 16.9922 50.3984 17.1875C50.0078 17.5742 50.0078 18.2109 50.3984 18.5977C50.7891 18.9883 51.4219 18.9883 51.8125 18.5977C52.2031 18.2109 52.2031 17.5742 51.8125 17.1875C51.6289 17 51.3828 16.8984 51.1211 16.8906ZM53.4648 20C53.2969 20.0039 53.1328 20.0508 52.9883 20.1328C52.7578 20.2656 52.5898 20.4844 52.5234 20.7422C52.4531 20.9961 52.4883 21.2695 52.625 21.5C52.8984 21.9766 53.5117 22.1406 53.9883 21.8633C54.4648 21.5898 54.6328 20.9766 54.3555 20.5C54.1719 20.1836 53.832 19.9922 53.4648 20ZM27.4648 20C27.125 20.0195 26.8164 20.207 26.6445 20.5C26.3672 20.9766 26.5312 21.5898 27.0117 21.8633C27.2383 22 27.5117 22.0352 27.7695 21.9648C28.0273 21.8984 28.2461 21.7305 28.375 21.5C28.6523 21.0234 28.4883 20.4102 28.0117 20.1367C27.8438 20.0391 27.6523 19.9922 27.4648 20ZM40.5 22.5C37.1992 22.5 34.5 25.1992 34.5 28.5C34.5 31.8008 37.1992 34.5 40.5 34.5C43.8008 34.5 46.5 31.8008 46.5 28.5C46.5 25.1992 43.8008 22.5 40.5 22.5ZM26 23.6211C25.5547 23.6211 25.1602 23.9258 25.0469 24.3594C24.9766 24.6172 25.0117 24.8906 25.1445 25.1172C25.2773 25.3477 25.4961 25.5156 25.7539 25.582C26.2891 25.7266 26.8359 25.4102 26.9805 24.875C27.1211 24.3438 26.8047 23.7969 26.2695 23.6523C26.1836 23.6289 26.0938 23.6172 26 23.6211ZM55.0273 23.6211C54.9258 23.6172 54.8281 23.625 54.7305 23.6523C54.1953 23.7969 53.8789 24.3438 54.0234 24.875C54.0898 25.1328 54.2578 25.3516 54.4883 25.4844C54.7188 25.6172 54.9922 25.6562 55.25 25.5859C55.5039 25.5156 55.7227 25.3477 55.8555 25.1211C55.9883 24.8906 56.0234 24.6172 55.9531 24.3594C55.8398 23.9375 55.4648 23.6367 55.0273 23.6211ZM40.5 24.5C42.7227 24.5 44.5 26.2773 44.5 28.5C44.5 30.7227 42.7227 32.5 40.5 32.5C38.2773 32.5 36.5 30.7227 36.5 28.5C36.5 26.2773 38.2773 24.5 40.5 24.5ZM25.5 27.5C24.9492 27.5 24.5 27.9492 24.5 28.5C24.5 29.0508 24.9492 29.5 25.5 29.5C26.0508 29.5 26.5 29.0508 26.5 28.5C26.5 27.9492 26.0508 27.5 25.5 27.5ZM55.5 27.5C54.9492 27.5 54.5 27.9492 54.5 28.5C54.5 29.0508 54.9492 29.5 55.5 29.5C56.0508 29.5 56.5 29.0508 56.5 28.5C56.5 27.9492 56.0508 27.5 55.5 27.5ZM26.0469 31.3828C25.9492 31.3789 25.8477 31.3906 25.75 31.418C25.2188 31.5586 24.9023 32.1055 25.0469 32.6406C25.1875 33.1758 25.7344 33.4922 26.2695 33.3477C26.8047 33.2031 27.1211 32.6562 26.9766 32.125C26.8633 31.6992 26.4883 31.3984 26.0469 31.3828ZM54.9805 31.3828C54.5312 31.3867 54.1406 31.6914 54.0234 32.125C53.8789 32.6602 54.1953 33.207 54.7305 33.3477C55.2656 33.4922 55.8125 33.1758 55.9531 32.6406C56.0977 32.1094 55.7812 31.5625 55.25 31.418C55.1602 31.3945 55.0703 31.3828 54.9805 31.3828ZM26.25 54.4414C15.7969 55.8867 7.5 58.9648 7.5 63.5C7.5 69.9961 24.5039 73.5 40.5 73.5C56.4961 73.5 73.5 69.9961 73.5 63.5C73.5 58.9648 65.2031 55.8867 54.75 54.4414C54.3711 55.0664 53.9883 55.6836 53.6094 56.2891C64.5703 57.6836 71.5 60.7109 71.5 63.5C71.5 67.2852 58.7695 71.5 40.5 71.5C22.2305 71.5 9.5 67.2852 9.5 63.5C9.5 60.7109 16.4297 57.6836 27.3906 56.2891C27.0117 55.6836 26.6289 55.0664 26.25 54.4414Z" fill={payload.request.img_color}/>
                        </svg>
                    </div>}
                    <div>
                       <h1>Location Permission</h1>
                       <p>To help us verify your location please grant us location permission.</p>
                    </div>
                    <br></br>
                    {!loading && <Button
                    size="large"
                    variant="contained"
                    sx={muiStyles.buttonStyles}
                    onClick={() => getLocationInfoFu()}>
                    Approve</Button>}
                    {loading && <CircularProgress sx={muiStyles.circleStyles} />}
                </div>
        </div>
    );
}
export default LocationPermission;

